// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "1bcc327de03d3d49","396": "cad07df9fcd62beb","460": "b847bc0b8f2334a5","498": "aa20865fd54fe17d","917": "abb286a2fed45763","985": "8d1915c32e58b378",}[chunkId] + ".chunk.js"
}